import React from "react";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    marginBottom: "1em",
  },
});
/**
 * @param {{ name: string, label: string, value: string, onChange: void }} props
 */

export default function Input({ name, label, value, onChange, hasError }) {
  const classes = useStyles();

  const displayError =
    hasError.length > 0 ? (
      <TextField
        error
        label="Error"
        defaultValue="Please type valid Serial Number"
        helperText="Serial number must consist of letters or numbers."
        variant="outlined"
        value={value}
        onChange={onChange}
        name={name}
      />
    ) : (
      <TextField
        className={classes.root}
        variant="outlined"
        label={label}
        name={name}
        value={value}
        onChange={onChange}
      />
    );

  return { ...displayError };
}
